export const slotDurationsInMins = [
  { title: "PremiumService.SlotDurations.30minutes", value: "30" },
  { title: "PremiumService.SlotDurations.1hour", value: "60" },
  { title: "PremiumService.SlotDurations.2hours", value: "120" },
  { title: "PremiumService.SlotDurations.3hours", value: "180" },
  { title: "PremiumService.SlotDurations.4hours", value: "240" }
]